import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { useForm } from '@/common/form/FormContext';
import { useMemo } from 'react';

const METRIC_LABELS = {
  RBT_AMT: 'Rebate Amount',
  SALES_AMT: 'Sales Amount',
  QTY: 'Quantity',
};

const SOURCES = {
  RBT: {
    title: 'by Rebate Quarter',
    description:
      'Rebate Lines totalled by the quarter their Rebate closed in, over the year ending on the selected quarter',
    xLabel: 'Rebate Quarter',
  },
  LEDGER: {
    title: 'by Earned Quarter',
    description:
      'Ledger Lines totalled by the quarter their earned Period closed in, over the year ending on the selected quarter',
    xLabel: 'Earned Quarter',
  },
};

export const InctvTrendCard = ({ source }) => {
  const { formValues } = useForm();
  const sourceSpec = SOURCES[source];

  const reqParam = useMemo(
    () => ({
      source,
      endPeriodId: formValues.endPeriodId,
      startPeriodId: formValues.startPeriodId,
      metric: formValues.metric,
      prodExpr: formValues.prodExpr,
      custExpr: formValues.custExpr,
      ctrtExpr: formValues.ctrtExpr,
      periodicity: formValues.periodicity,
    }),
    [
      source,
      formValues.endPeriodId,
      formValues.startPeriodId,
      formValues.metric,
      formValues.prodExpr,
      formValues.custExpr,
      formValues.ctrtExpr,
      formValues.periodicity,
    ],
  );

  const metricLabel = METRIC_LABELS[formValues.metric] ?? METRIC_LABELS.RBT_AMT;

  return (
    <DashboardCard
      title={metricLabel + ' ' + sourceSpec.title}
      description={sourceSpec.description}
      module="sc"
      plugin="INCTV_TREND_DATA_PLUGIN"
      reqParam={reqParam}
    >
      {(data) => <CartesianChart data={data} xLabel={sourceSpec.xLabel} yLabel={metricLabel} allowNegative />}
    </DashboardCard>
  );
};
